var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
import { DevPlanMethod, } from './models';
export var getInitialState = function () { return ({
    user: {
        name: '',
        meta: {
            last_name: '',
        },
        email: '',
        password: '',
        verifyingPassword: '',
        email_verified: false,
    },
    organization: {
        name: '',
        description: '',
        company_name: '',
        contact_person: '',
        contact_number: '',
        contact_email: '',
        company_number: '',
        currency: 'sek',
        country: 'SE',
        email_verified: false,
    },
    inputValidations: {
        name: '',
        company_name: '',
        contact_email: '',
        email: '',
        password: '',
        verifyingPassword: '',
        contact_person: '',
    },
    emailVerification: {
        verificationCode: '',
        verificationSent: false,
        verified: false,
        valid: false,
    },
    organizationEmailVerification: {
        verificationCode: '',
        verificationSent: false,
        verified: false,
        valid: false,
    },
    emailVerificationType: '',
    loading: false,
    error: false,
    response: null,
    step: 1,
    verifyingEmail: false,
    sendingVerifyEmail: false,
    signupId: '',
    validating: false,
    userMetaLoading: false,
    billingInfo: {},
    userMeta: {},
    organizationMeta: {},
    devPlanMeta: {},
    devPlans: [],
    devPlanId: '',
    selected: false,
    currency: '',
    interval: DevPlanMethod.Annually,
    campaign: '',
    token: '',
    invoiceEnabled: false,
    devPlanLoading: false,
    devPlanError: false,
    orgSaveLoading: false,
    orgSaveError: false,
    devPlansLoading: false,
    signupCountryLoading: false,
    checked: false,
    userAndOrgLoading: false,
    userAndOrgError: false,
    verifiedEmails: [],
    showCompanySignup: false,
}); };
function statesReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        switch (action.type) {
            case 'SEND_VERIFY_EMAIL_REQUEST':
                state.loading = true;
                state.error = false;
                state.response = null;
                state.sendingVerifyEmail = true;
                if (state.emailVerificationType === 'user') {
                    state.user.email_verified = false;
                    state.emailVerification.verified = false;
                }
                else if (state.emailVerificationType === 'organization') {
                    state.organization.email_verified = false;
                    state.organizationEmailVerification.verified = false;
                }
                break;
            case 'SEND_VERIFY_EMAIL_SUCCESS':
                state.loading = false;
                state.error = false;
                state.sendingVerifyEmail = false;
                break;
            case 'SEND_VERIFY_EMAIL_FAILURE':
                state.loading = false;
                state.error = action.error;
                state.sendingVerifyEmail = false;
                if (state.emailVerificationType === 'user') {
                    state.user.email_verified = false;
                    state.emailVerification.verified = false;
                }
                else if (state.emailVerificationType === 'organization') {
                    state.organization.email_verified = false;
                    state.organizationEmailVerification.verified = false;
                }
                break;
            case 'CREATE_USER_REQUEST':
                state.response = null;
                state.error = false;
                break;
            case 'CREATE_USER_SUCCESS':
                state.loading = false;
                state.error = false;
                state.user[action.key] = action.data;
                break;
            case 'ADD_SIGNUP_STATE_SUCCESS':
                state.loading = false;
                state.error = false;
                state[action.key] = action.data;
                break;
            case 'CREATE_USER_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'CREATE_EMAIL_VERIFICATION_REQUEST':
                state.response = null;
                state.error = false;
                break;
            case 'CREATE_EMAIL_VERIFICATION_SUCCESS':
                state.loading = false;
                state.error = false;
                state.emailVerification[action.key] = action.data;
                if (action.key === 'verificationSent') {
                    state.emailVerification.verificationSent = action.data;
                }
                if (action.key === 'verified') {
                    state.emailVerification.verified = action.data;
                }
                break;
            case 'CREATE_EMAIL_VERIFICATION_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'CREATE_ORG_EMAIL_VERIFICATION_REQUEST':
                state.response = null;
                state.error = false;
                break;
            case 'CREATE_ORG_EMAIL_VERIFICATION_SUCCESS':
                state.loading = false;
                state.error = false;
                state.organizationEmailVerification[action.key] = action.data;
                if (action.key === 'verificationSent') {
                    state.organizationEmailVerification.verificationSent = action.data;
                }
                if (action.key === 'verified') {
                    state.organizationEmailVerification.verified = action.data;
                }
                break;
            case 'CREATE_0RG_EMAIL_VERIFICATION_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'NEXT_STEP_SUCCESS':
                state.loading = false;
                state.error = false;
                state.step = action.step;
                break;
            case 'SIGNUP_AS_COMPANY_SUCCESS':
                state.loading = false;
                state.error = false;
                state.checked = action.checked;
                if (action.checked) {
                    if (!state.organization.contact_email) {
                        state.organization.contact_email = state.user.email;
                        state.organizationEmailVerification.valid =
                            state.emailVerification.valid;
                        state.organizationEmailVerification.verified =
                            state.emailVerification.verified;
                        state.organization.email_verified = state.user.email_verified;
                    }
                    if (!state.organization.contact_person)
                        state.organization.contact_person = state.user.name;
                }
                break;
            case 'CREATE_CMS_ACCOUNT_REQUEST':
                state.loading = true;
                state.response = null;
                state.organization.name = (_a = action.organization) === null || _a === void 0 ? void 0 : _a.company_name;
                state.organization.company_name = (_b = action.organization) === null || _b === void 0 ? void 0 : _b.company_name;
                state.organization.contact_person = (_c = action.organization) === null || _c === void 0 ? void 0 : _c.contact_person;
                state.organization.contact_number = (_d = action.organization) === null || _d === void 0 ? void 0 : _d.contact_number;
                state.organization.company_number = (_e = action.organization) === null || _e === void 0 ? void 0 : _e.company_number;
                state.organization.currency = (_f = action.organization) === null || _f === void 0 ? void 0 : _f.currency;
                state.organization.contact_email = (_g = action.organization) === null || _g === void 0 ? void 0 : _g.contact_email;
                state.organization.country = (_h = action.organization) === null || _h === void 0 ? void 0 : _h.country;
                state.error = false;
                break;
            case 'CREATE_CMS_ACCOUNT_SUCCESS':
                state.loading = false;
                state.error = false;
                state.response = action.response;
                if (((_j = action === null || action === void 0 ? void 0 : action.response) === null || _j === void 0 ? void 0 : _j.type) === 'ACCOUNT_CREATION' &&
                    ((_k = action === null || action === void 0 ? void 0 : action.response) === null || _k === void 0 ? void 0 : _k.orgExists)) {
                    state.step = 6;
                }
                break;
            case 'CREATE_CMS_ACCOUNT_FAILURE':
                state.loading = false;
                state.error = action.error;
                break;
            case 'COMPLETE_SIGNUP_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'COMPLETE_SIGNUP_SUCCESS':
                state.loading = false;
                state.response = action.response;
                state.error = false;
                break;
            case 'COMPLETE_SIGNUP_FAILURE':
                state.loading = false;
                state.error = action.error;
                break;
            case 'COMPLETE_SIGNUP_FOR_INVOICE_REQUEST':
                state.loading = true;
                break;
            case 'COMPLETE_SIGNUP_FOR_INVOICE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.step = 4;
                break;
            case 'COMPLETE_SIGNUP_FOR_INVOICE_FAILURE':
                state.loading = false;
                state.error = action.error;
                break;
            case 'CREATE_COMPANY_REQUEST':
                state.loading = true;
                state.response = null;
                state.error = false;
                break;
            case 'CREATE_COMPANY_SUCCESS':
                state.loading = false;
                state.error = false;
                state.organization[action.key] = action.data;
                if (action.key === 'company_name') {
                    state.organization.name = action.data;
                }
                break;
            case 'CREATE_COMPANY_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'SAVE_USER_META_REQUEST':
                state.userMetaLoading = true;
                state.error = false;
                break;
            case 'SAVE_USER_META_SUCCESS':
                state.userMetaLoading = false;
                state.error = false;
                state.userMeta = action.userMeta;
                break;
            case 'SAVE_USER_META_FAILURE':
                state.userMetaLoading = false;
                state.error = true;
                break;
            case 'SAVE_USER_ONLY_REQUEST':
                state.userAndOrgLoading = true;
                state.userAndOrgError = false;
                break;
            case 'SAVE_USER_ONLY_SUCCESS':
                state.userAndOrgLoading = false;
                state.userAndOrgError = false;
                state.organizationMeta = action.organizationMeta;
                break;
            case 'SAVE_USER_ONLY_FAILURE':
                state.userAndOrgLoading = false;
                state.userAndOrgError = true;
                break;
            case 'SAVE_ORG_REQUEST':
                state.orgSaveLoading = true;
                state.orgSaveError = false;
                break;
            case 'SAVE_ORG_SUCCESS':
                state.orgSaveLoading = false;
                state.orgSaveError = false;
                state.organizationMeta = action.organizationMeta;
                break;
            case 'SAVE_ORG_FAILURE':
                state.orgSaveLoading = false;
                state.orgSaveError = true;
                break;
            case 'SAVE_DEV_PLAN_REQUEST':
                state.devPlanLoading = true;
                state.devPlanError = false;
                break;
            case 'SAVE_DEV_PLAN_SUCCESS':
                state.devPlanLoading = false;
                state.devPlanError = false;
                state.devPlanMeta = action.devPlanMeta;
                state.step = 3;
                break;
            case 'SAVE_DEV_PLAN_FAILURE':
                state.devPlanLoading = false;
                state.devPlanError = true;
                break;
            case 'GET_SIGNUP_FLOW_REQUEST':
                state.devPlansLoading = true;
                state.error = false;
                break;
            case 'GET_SIGNUP_FLOW_SUCCESS':
                state.devPlansLoading = false;
                state.error = false;
                state.devPlans = action.devPlans;
                break;
            case 'GET_SIGNUP_FLOW_FAILURE':
                state.devPlansLoading = false;
                state.error = true;
                break;
            case 'SET_SELECTED_DEV_PLAN_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'SET_SELECTED_DEV_PLAN_DETAILS_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'SET_SELECTED_DEV_PLAN_DETAILS_SUCCESS':
                {
                    state.loading = false;
                    state.error = false;
                    state.selected = action.selected;
                    if (state.selected) {
                        state.devPlanId = action.devPlanId;
                        state.currency = action.currency;
                    }
                    else {
                        state.devPlanId = '';
                        state.currency = '';
                    }
                    state.devPlans = state.devPlans.map(function (item) {
                        return item.id === action.devPlanId
                            ? __assign(__assign({}, item), { active_dev_plan: !item.active_dev_plan }) : __assign(__assign({}, item), { active_dev_plan: false });
                    });
                }
                break;
            case 'SET_SELECTED_DEV_PLAN_DETAILS_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'SET_SELECTED_DEV_PLAN_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'VERIFY_EMAIL_REQUEST':
                state.loading = true;
                state.response = null;
                state.verifyingEmail = true;
                state.error = false;
                if (state.emailVerificationType === 'user') {
                    state.user.email_verified = false;
                    state.emailVerification.verified = false;
                }
                else if (state.emailVerificationType === 'organization') {
                    state.organization.email_verified = false;
                    state.organizationEmailVerification.verified = false;
                }
                break;
            case 'VERIFY_EMAIL_SUCCESS':
                state.loading = false;
                state.verifyingEmail = false;
                state.error = false;
                state.response = action.response;
                if ((_l = action.response) === null || _l === void 0 ? void 0 : _l.success) {
                    if (state.emailVerificationType === 'user') {
                        state.user.email_verified = true;
                        state.emailVerification.verified = true;
                        state.inputValidations.email = '';
                        if (state.user.email === state.organization.contact_email) {
                            state.organization.email_verified = true;
                            state.organizationEmailVerification.verified = true;
                        }
                        if (state.user.email)
                            state.verifiedEmails = __spreadArray(__spreadArray([], state.verifiedEmails, true), [
                                state.user.email,
                            ], false);
                    }
                    else if (state.emailVerificationType === 'organization') {
                        state.organization.email_verified = true;
                        state.organizationEmailVerification.verified = true;
                        state.inputValidations.contact_email = '';
                        if (state.user.email === state.organization.contact_email) {
                            state.user.email_verified = true;
                            state.emailVerification.verified = true;
                        }
                        if (state.organization.contact_email)
                            state.verifiedEmails = __spreadArray(__spreadArray([], state.verifiedEmails, true), [
                                state.organization.contact_email,
                            ], false);
                    }
                }
                break;
            case 'VERIFY_EMAIL_FAILURE':
                state.loading = false;
                state.verifyingEmail = false;
                state.error = action.error;
                if (state.emailVerificationType === 'user') {
                    state.user.email_verified = false;
                    state.emailVerification.verified = false;
                }
                else if (state.emailVerificationType === 'organization') {
                    state.organization.email_verified = false;
                    state.organizationEmailVerification.verified = false;
                }
                break;
            case 'FORM_NAVIGATE':
                state.step -= 1;
                break;
            case 'SET_EMAIL_VERIFICATION_TYPE':
                state.emailVerificationType = action.emailVerificationType;
                break;
            case 'RESET_EMAIL_VERIFICATION':
                if (action.emailVerificationType === 'user') {
                    if (state.user.email &&
                        state.verifiedEmails.includes(state.user.email)) {
                        state.user.email_verified = true;
                        state.emailVerification.verified = true;
                    }
                    else {
                        state.user.email_verified = false;
                        state.emailVerification.verified = false;
                    }
                }
                else if (action.emailVerificationType === 'organization') {
                    if (state.organization.contact_email &&
                        state.verifiedEmails.includes(state.organization.contact_email)) {
                        state.organization.email_verified = true;
                        state.organizationEmailVerification.verified = true;
                    }
                    else {
                        state.organization.email_verified = false;
                        state.organizationEmailVerification.verified = false;
                    }
                }
                break;
            case 'GENERATE_SIGNUP_TOKEN_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'GENERATE_SIGNUP_TOKEN_SUCCESS':
                state.loading = false;
                state.error = false;
                state.token = action.token;
                state.invoiceEnabled = action.invoiceEnabled || false;
                break;
            case 'GENERATE_SIGNUP_TOKEN_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'VALIDATE_URL_REQUEST':
                state.error = false;
                state.response = null;
                state.validating = true;
                break;
            case 'VALIDATE_URL_SUCCESS':
                state.error = false;
                state.signupId = action.response;
                state.validating = false;
                break;
            case 'VALIDATE_URL_FAILURE':
                state.error = action.error;
                state.validating = false;
                break;
            case 'CHANGE_EMAIL_VERIFICATION_REQUEST':
                state.error = true;
                if (state.emailVerificationType === 'user')
                    state.user.email_verified = false;
                else if (state.emailVerificationType === 'organization') {
                    state.organization.email_verified = !!action.isSameEmail;
                }
                break;
            case 'SET_INPUT_VALIDATIONS':
                state.inputValidations = action.inputValidations;
                break;
            case 'CLEAR_INPUT_VALIDATION':
                state.inputValidations[action.input] = '';
                break;
            case 'SHOW_COMPANY_SIGNUP':
                state.showCompanySignup = true;
                break;
            case 'REMOVE_USER_DATA_WHEN_LOGOUT':
                state = Object.assign(state, getInitialState());
                break;
            default:
                break;
        }
    });
}
export default statesReducer;
